import axios from "axios";
import { useSelector } from "react-redux";
import { useQuery , useInfiniteQuery } from "@tanstack/react-query";
import { API } from "../../config";
import { useQueryClient } from "@tanstack/react-query";

const fetchPatients = async ({ userId, token, page, searchDetails }) => {
  const { data } = await axios({
    url: `${API}/patient-list/${userId}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: { ...searchDetails, page, limit: 15 },
  });

  return data; // Axios automatically parses JSON response
};

export const usePatients = (page, searchDetails) => {
  const { userInfo } = useSelector((state) => state.userLogin);

  return useQuery(
    ['patients', userInfo._id, page, searchDetails],
    () => fetchPatients({ userId: userInfo._id, token: userInfo.token, page, searchDetails }),
    {
      keepPreviousData: true,
      retry: 1,
      onError: (error) => {
        console.error('Fetching patients failed:', error.message);
      },
    }
  );
};

export const useInvalidatePatients = () => {
  const queryClient = useQueryClient();

  return () => {
      queryClient.invalidateQueries(["patients"]);
  };
};